(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-actions"] && !Shopify.designMode) return;
  try {
    function initL1NavLanguages() {
    var code = (new URLSearchParams(location.search).get('l1_lang') || document.documentElement.lang || 'en').slice(0, 2);
    var flags = { pt: '🇵🇹', en: '🇬🇧', es: '🇪🇸' };
    if (!flags[code]) code = 'en';
    document.querySelectorAll('[data-l1-nav-language]').forEach(function (root) {
      root.querySelector('.l1-nav-language-flag').textContent = flags[code];
      root.querySelector('.l1-nav-language-code').textContent = code.toUpperCase();
      root.querySelector('summary').setAttribute('aria-label', {pt:'Alterar idioma',en:'Change language',es:'Cambiar idioma'}[code]);
      root.querySelectorAll('[data-l1-language]').forEach(function (button) {
        if (button.dataset.l1Language === code) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
    });
  }
  initL1NavLanguages();
  document.addEventListener('shopify:section:load', initL1NavLanguages);
  document.addEventListener('click', function (event) {
    var choice = event.target.closest('.l1-nav-language-choice');
    if (choice) {
      var root = choice.closest('[data-l1-nav-language]');
      root.open = false;
      if (choice.getAttribute('aria-current') === 'true') return;
      if (choice.dataset.l1NativeCode && Number(choice.dataset.l1NativeCount) > 1) {
        var form = choice.closest('form');
        form.elements.language_code.value = choice.dataset.l1NativeCode;
        var url = new URL(location.href);
        url.searchParams.delete('l1_lang');
        if (form.elements.return_to) form.elements.return_to.value = url.pathname + url.search + url.hash;
        form.requestSubmit();
      } else {
        var url = new URL(location.href);
        url.searchParams.set('l1_lang', choice.dataset.l1Language === 'pt' ? 'pt-PT' : choice.dataset.l1Language);
        location.href = url.href;
      }
    }
    document.querySelectorAll('[data-l1-nav-language][open]').forEach(function (root) {
      if (!root.contains(event.target)) root.open = false;
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-l1-nav-language][open]').forEach(function (root) {
      root.open = false;
      root.querySelector('summary').focus();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
